import { useSelector } from 'react-redux';
import { AssistantSmartTipsEntity } from '@mews-commander/data-access';
import { SmartTip } from '@mews/b2b-ui';
import { lt, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { Spinner } from '@optimus-web/core';
import { isCurrentEnterpriseSmartTipsEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useAssistantSmartTipsQuery } from '../../../../assistant/query/useAssistantSmartTipsQuery';

interface SmartTipsCustomerListProps {
    id: string;
    chainId: string;
    enterpriseIds: string;
}

export const SmartTipsCustomerList = (props: SmartTipsCustomerListProps) => {
    const { id, chainId, enterpriseIds } = props;
    const smartTipsReservationGuestsEnabled = useFeatureFlag(FeatureFlag.smartTipsReservationGuestsEnabled);
    const isSmartTipsEnabled = useSelector(isCurrentEnterpriseSmartTipsEnabled);
    const { data, isFetching, error } = useAssistantSmartTipsQuery(
        {
            id,
            chainId,
            entity: AssistantSmartTipsEntity.Customer,
            enterpriseIds: [enterpriseIds],
        },
        smartTipsReservationGuestsEnabled
    );
    if (!isSmartTipsEnabled && !smartTipsReservationGuestsEnabled) return null;

    if (isFetching) return <Spinner size="small" />;

    return (
        <SmartTip
            label={data?.tips ? lt('AssistantSmartTipsTitle') : lt('AssistantSmartTipsNotAvailableTitle')}
            disclaimer={data?.tips ? lt('AssistantSmartTipsDisclaimer') : null}
            textMoreButton={lt('MoreInfo')}
            textLessButton={lt('LessInfo')}
        >
            {error ? lt('AssistantSmartTipsErrorMessage') : data?.tips || lt('AssistantSmartTipsNotAvailableBody')}
        </SmartTip>
    );
};
